import React from "react";

import { useMemo, useState, useCallback, useEffect } from "react";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import style from "./style";
// import { Grid, showToast } from "@shared/components";
import {
  debounce,
  getFormattedDate,
  getPageConfig,
  setPageConfig,
  queryStringBuilder,
  exportToFile,
} from "@client/utils";
import WhitelistComponentView from "./view";
// import { WhitelistService } from "@consumers/services";
import Box from "@mui/material/Box";
import { toast } from "react-toastify";
import Service from "./service";

const defaultState = {
  entries: [],
  isFiltering: false,
  isGridView: true,
  isPaginationEnabled: true,
  isLoading: true,
  totalEntries: 0,
  pageSize: 5,
  pageNumber: 1,
  search: "",
  sort: null,
  selectedRows: [],
  statusFilters: [],
  areAllSelected: false,
  filters: [],
  isFiltering: false,
  order: null,
  orderBy: "",
};

let gridHelpers = null;
const onGridReady = (event) => (gridHelpers = event);

const WhitelistComponent = () => {
  // const pageConfig = getPageConfig(PAGE_KEYS.WHITELIST_CLIENTS) || {};
  const [state, setState] = useState({
    ...defaultState,
    // pageSize:
    //   pageConfig && pageConfig.pageSize
    //     ? pageConfig.pageSize
    //     : defaultState.pageSize,
  });

  const getQueryString = () => {
    const filters = [
      ...(state.statusFilters.length === 2 ? [] : state.statusFilters),
    ];

    let searchArray = [];

    if (state.search) {
      searchArray = ["name", "rc_account_id"].map((element) => {
        if (element === "rc_account_id") {
          return { field: element, value: state.search, type: "=" };
        } else {
          return { field: element, value: state.search };
        }
      });
    }

    // return queryStringBuilder(
    //   state.pageSize,
    //   (state.pageNumber - 1) * state.pageSize,
    //   searchArray,
    //   filters,
    //   state.sort,
    //   state.search !== ""
    // );
  };

  // Data fetchers

  const fetchWhitelistClients = async (
    pageNumber = 1,
    pageSize = 5,
    sort = null,
    filters = [],
    order = null,
    orderBy = "",
    filter = []
  ) => {
    setState((prevState) => ({ ...prevState, isLoading: true }));

    let filtersArr = [
      ...filter.map((filter) => ({
        ...filter,
        value: filter?.value?.value || filter?.value,
      })),
    ];
    const queryString = queryStringBuilder(
      pageSize,
      (pageNumber - 1) * pageSize,
      [],
      filtersArr,
      { field: orderBy, order: order }
    );
    const { data, error } = await Service.get(queryString);
    if (error) {
      toast.error(Array.isArray(error) ? error[0]?.message : error);
      setState((prevState) => ({ ...prevState, isLoading: false }));
      return;
    } else {
      gridHelpers && gridHelpers.resetSelection();
      setState((prevState) => ({
        ...prevState,
        entries: data.whitelistedClients,
        isLoading: false,
        totalEntries: data.count,
        selectedRows: [],
      }));
      return data;
    }
    // eslint-disable-next-line
  };

  const handleExport = debounce(async () => {
    const selectedNotificationIds = state.selectedRows
      .slice()
      .map((row) => row.id);
    const fileName = `Whitelist_export_${
      state.selectedNotificationIds?.join("_") || "all"
    }`;

    toast.info("Exporting");
    let queryString = queryStringBuilder(
      0,
      0,
      [],
      state.filters,
      state.sort
    );
    if (!!state.selectedRows.length) {
      queryString += `${queryString ? "&" : "?"}ids=${state.selectedRows.join(
        ","
      )}`;
    }
    const { data, error } = await Service.exportWhiteList(queryString);
    if (error) {
      toast.error(Array.isArray(error) ? error[0] && error[0].message : error);
    } else {
      exportToFile(data, fileName);
    }
  }, 1000);

  // Lifecycle hooks
  useEffect(() => {
    fetchWhitelistClients(
      state.pageNumber,
      state.pageSize,
      state.sort,
      state.statusFilters,
      state.order,
      state.orderBy,
      state.filters
    );
  }, [
    state.pageNumber,
    state.pageSize,
    state.sort,
    state.statusFilters,
    state.order,
    state.orderBy,
    state.filters,
  ]);

  // Handlers
  /**
   * Reset filter state when filter is closed and fetch data.
   */
  const handleFilterClose = useCallback(() => {
    setState((prevState) => ({
      ...prevState,
      isFiltering: false,
      search: "",
      statusFilters: [],
    }));
  }, []);

  /**
   * Update state when user selects any row from grid or card view.
   */
  const handleSelectionChange = useCallback((selectedRows) => {
    setState((prevState) => ({ ...prevState, selectedRows }));
  }, []);

  const handleAllSelectionChange = useCallback((areAllSelected) => {
    setState((prevState) => ({ ...prevState, areAllSelected }));
  }, []);

  /**
   * Update state when user sorts data inside grid.
  //  */
  // const handleSorting = useCallback((fieldObj, order) => {
  //   let sortObj = null;
  //   setState((prevState) => ({
  //     ...prevState,
  //     order: order,
  //     orderBy: order ? fieldObj.field || fieldObj.fieldName : null,
  //     selectedRows: defaultState.selectedRows,
  //   }));
  //   // if (order) {
  //   //   sortObj = { fieldObj, order };
  //   // }

  //   gridHelpers.resetSelection();
  //   // debounce(() => {
  //   //   setState((prevState) => ({ ...prevState, sort: sortObj }));
  //   // }, 500)();
  // }, []);
  const handleSorting = useCallback((fieldObj, order) => {
    setState((prevState) => ({
      ...prevState,
      order,
      orderBy: order ? fieldObj.field || fieldObj.fieldName : null,
    }));
  }, []);

  /**
   * Invoke the debounced function that is responsible for updating state
   * when user is searching for something in filter.
   */
  const handleSearchChange = useCallback(
    // debounce(
    //   search =>
    //     setState(prevState => ({ ...prevState, search, pageNumber: 1 })),
    //   1000
    // ),
    []
  );

  const handlePageNumberChange = useCallback((pageNumber) => {
    setState((prevState) => ({ ...prevState, pageNumber }));
    // setPageConfig(PAGE_KEYS.WHITELIST_CLIENTS, {
    //   pageNumber,
    // });
  }, []);

  const filterData = useCallback((filters = []) => {
    setState((prevState) => ({
      ...prevState,
      filters,
      pageNumber: 1,
    }));
  }, []);

  const handlePageSizeChange = useCallback((pageSize) => {
    setState((prevState) => ({ ...prevState, pageSize }));
    // setPageConfig(PAGE_KEYS.WHITELIST_CLIENTS, {
    //   pageSize,
    // });
  }, []);

  // Data grid config
  const columns = [
    {
      id: "name",
      label: "Client Name",
      canSort: true,
      field: "name",
      render: (row) => (
        <Tooltip title={row.name} placement="top-start">
          <Typography variant="body2" noWrap>
            {row.name}
          </Typography>
        </Tooltip>
      ),
    },
    {
      id: "rc_account_id",
      label: "RC Account UID",
      canSort: true,
      field: "rc_account_id",
      hasEllipses: true,
      render: (row) => (
        <Typography variant="body2">{row.rc_account_id}</Typography>
      ),
    },
    {
      id: "type",
      label: "Client Type",
      canSort: true,
      field: "type",
      render: (row) => <Typography variant="body2">{row.type}</Typography>,
    },
    {
      id: "status",
      label: "Status",
      canSort: true,
      field: "status",
      render: (row) => <Typography variant="body2">{row.status}</Typography>,
    },
    {
      id: "activation_date",
      label: "Activation Date",
      canSort: true,
      field: "activation_date",
      render: (row) => {
        return (
          <Typography variant="body2">
            {row.activation_date === null
              ? "-"
              : getFormattedDate(new Date(row.activation_date))}
          </Typography>
        );
      },
    },
    {
      id: "expiration_date",
      label: "Expiration Date",
      canSort: true,
      field: "expiration_date",
      render: (row) => (
        <Typography variant="body2">
          {row.expiration_date === null
            ? "N/A"
            : getFormattedDate(new Date(row.expiration_date))}
        </Typography>
      ),
    },
    {
      label: "Logo",
      className: style.statusColumn,
      fieldName: "enabled",
      headerClassName: style.statusColumn,
      render: (row) => {
        if (row.client_logo_path) {
          return (
            <img
              alt={row.name + `'s logo`}
              src={row.client_logo_path}
              style={{ width: "124px", height: "36px" }}
            />
          );
        } else {
          return (
            <Box
              sx={{
                background: "rgb(249, 249, 249)",
                border: "1px solid rgb(220, 221, 225)",
                height: 36,
                width: 124,
              }}
            >
              <Typography
                sx={{ alignItems: "center", mt: 1, ml: 2 }}
                variant="body2"
              >
                Not Available
              </Typography>
            </Box>
          );
        }
      },
    },
  ];
  //eslint-disable-next-line

  const filters = [
    {
      field: "type",
      fieldToDisplay: "Client Type",
      operatorType: "array",
      options: [
        { label: "Customer", value: "customer" },
        { label: "Partner", value: "partner" },
      ],
    },
    {
      field: "name",
      fieldToDisplay: "Client Name",
      operatorType: "string",
    },
    {
      field: "rc_account_id",
      fieldToDisplay: "RC Account ID",
      operatorType: "string",
    },
    {
      field: "status",
      fieldToDisplay: "Status",
      operatorType: "array",
      options: [
        { label: "Active", value: "active" },
        { label: "Inactive", value: "inactive" },
      ],
    },
  ];

  return (
    <WhitelistComponentView
      columns={columns}
      filters={filters}
      entries={state.entries}
      totalEntries={state.totalEntries}
      search={state.search}
      pageSize={state.pageSize}
      pageNumber={state.pageNumber}
      isLoading={state.isLoading}
      isFiltering={state.isFiltering}
      handleExport={handleExport}
      handleFilterClose={handleFilterClose}
      handlePageNumberChange={handlePageNumberChange}
      handlePageSizeChange={handlePageSizeChange}
      onGridReady={onGridReady}
      handleSearchChange={handleSearchChange}
      handleSelectionChange={handleSelectionChange}
      handleAllSelectionChange={handleAllSelectionChange}
      handleSorting={handleSorting}
      filterData={filterData}
      order={state.order}
      orderBy={state.orderBy}
    />
  );
};

export default WhitelistComponent;
